import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="payment"
export default class extends Controller {
  static targets = ["manualButton", "manualSection"]

  connect() {
  }

  toggleManualPayment() {
    this.manualSectionTarget.classList.toggle("hidden")

    // Add active state to the button when selected
    if (!this.manualSectionTarget.classList.contains("hidden")) {
      this.manualButtonTarget.classList.add("border-blue-500", "bg-blue-50")
    } else {
      this.manualButtonTarget.classList.remove("border-blue-500", "bg-blue-50")
    }
  }
}